import script from "./MailSent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailSent.vue?vue&type=script&setup=true&lang=ts"

import "./MailSent.vue?vue&type=style&index=0&id=984978fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-984978fa"]])

export default __exports__